import { create } from 'zustand';
import { RoleConfigStoreInterface } from './types';

const RoleConfigStore = create<RoleConfigStoreInterface>()((set) => {
  return {
    roleConfig: null,
    roleConfigTags: null,
    roleConfigActions: null,

    setRoleConfig: (config) => {
      set(() => ({
        roleConfig: config,
      }));
    },

    setRoleConfigTags: (tags) => {
      set(() => ({
        roleConfigTags: tags,
      }));
    },

    setRoleConfigActions: (actions) => {
      set(() => ({
        roleConfigActions: actions,
      }));
    },
  };
});

export default RoleConfigStore;
